import React from 'react';
import classNames from 'classnames/bind';
import { Status } from 'components';

import PropTypes from 'prop-types';
import styles from '../styles.pcss';
const cx = classNames.bind(styles);

export const ErrorStatus = ({ error }) => (
  <Status className={[cx('error'), 'error']} emoji="statusFail">
    {error?.message || error}
  </Status>
);

ErrorStatus.propTypes = {
  error: PropTypes.oneOf([{
    message: PropTypes.string,
  }, PropTypes.string]),
};
